export default function() {
  (
    () => {
      function checkLoggedInCookie() {
        const isLoggedIn = sessionStorage.getItem( "logged_in" );
        return ( isLoggedIn === "true" );
      }

      if ( !window.dataLayer ) {
        window.dataLayer = [];
      }

      if ( checkLoggedInCookie() === true ) {
        window.dataLayer.push( {
          'event': 'logged_in'
        } );
      }
    }
  )();
}
